import { COMMON_DOCUMENTS } from './documents';
export const QA = {
    code: 'QA',
    name: 'Qatar',
    profileVersion: 1,
    readiness: 'ready',
    timezone: 'Asia/Qatar',
    weekend: [5, 6],
    firstDayOfWeek: 0,
    currency: { code: 'QAR', displayFractionDigits: 2, roundToWholeUnits: false },
    subdivisions: [],
    branchSubdivision: 'none',
    locales: {
        ui: ['en', 'ar'],
        defaultUi: 'en',
        documentSecondary: 'ar',
        secondaryOnTaxDocuments: 'default_on',
        secondaryOnClinicalDocuments: 'default_off',
        formatting: { en: 'en-GB', ar: 'ar-QA-u-nu-latn' },
    },
    phone: { callingCode: '974', trunkPrefix: null, nationalLengths: [8], mobilePattern: '^[3567]\\d{7}$', example: '33123456' },
    names: { parts: ['first', 'father', 'last'], labels: { father: 'Father name (optional)' }, askLocalName: true },
    identity: {
        documents: [
            {
                type: 'qa_qid',
                labelKey: 'identity.qa_qid',
                label: 'QID',
                pattern: '^\\d{11}$',
                normalise: 'digits',
                checksum: 'none',
                onChecksumFail: 'warn',
                onPatternFail: 'refuse',
                example: '28412345678',
            },
            ...COMMON_DOCUMENTS,
        ],
        defaultType: 'qa_qid',
        autoDetect: false,
        capture: { hospital: 'optional', lab: 'optional', pharmacy: 'optional' },
        askNationality: true,
        dobCalendars: ['gregory'],
    },
    practitionerRegistries: [{ code: 'DHP', label: 'DHP licence' }],
    tax: [
        {
            code: 'none',
            effectiveFrom: '2026-01-01',
            registration: null,
            companyRegistrationLabelKey: null,
            companyRegistrationLabel: null,
            standardRatePct: null,
            serviceDefaultCategory: 'out_of_scope',
            productDefaultCategory: 'out_of_scope',
            qr: null,
            citizenRelief: null,
        },
    ],
    eInvoicing: { scheme: null, mandatory: 'no', fromDate: null, appliesTo: [] },
    addOns: [],
    feeSplittingDefault: false,
};
//# sourceMappingURL=qa.js.map